export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9996.3430bebd.jpg";